import { proxyAPIs } from 'api';

export const getEncryptedText = async payload => {
  const respData = await proxyAPIs.encryptData(JSON.stringify(payload));

  if (respData?.status === 200) {
    return respData?.data || '';
  }

  return '';
};
